
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/media/[id]",
      function () {
        return require("private-next-pages/media/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/media/[id]"])
      });
    }
  